import { AfterViewInit, Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { environment } from 'src/environments/environment';
import Article from 'src/smoothr-web-app-core/models/Article';
import Compound from 'src/smoothr-web-app-core/models/Compound';
import { numberD } from 'src/smoothr-web-app-core/utils/utils';
export interface NutritionValue {
	$numberDecimal: string;
}
export interface Nutrition {
	portionInG: NutritionValue;
	energyKcalPerPortion: NutritionValue;
	energyKcalPer100g: NutritionValue;
	energyKjPerPortion: NutritionValue;
	energyKjPer100g: NutritionValue;
	fatPerPortion: NutritionValue;
	fatPer100g: NutritionValue;
	saturatesPerPortion: NutritionValue;
	saturatesPer100g: NutritionValue;
	carbohydratePerPortion: NutritionValue;
	carbohydratePer100g: NutritionValue;
	sugarPerPortion: NutritionValue;
	sugarPer100g: NutritionValue;
	proteinPerPortion: NutritionValue;
	proteinPer100g: NutritionValue;
	saltPerPortion: NutritionValue;
	saltPer100g: NutritionValue;
	unit: string;
}

@Component({
	selector: 'app-short-info-modal',
	templateUrl: './short-info-modal.component.html',
	styleUrls: ['short-info-modal.component.scss'],
	standalone: false,
})
export class ShortInfoModalComponent implements AfterViewInit {
	article: Article;
	compound: Compound;
	environment = environment;
	numberD = numberD;
	private modalCtrl = inject(ModalController);

	constructor() {}
	ngAfterViewInit(): void {
		console.log('ShortInfoModalComponent  article ---', this.article.compound.traces);
	}
	static async show(modalCtrl: ModalController, article: Article) {
		const modal = await modalCtrl.create({
			cssClass: 'allergens-modal',
			component: ShortInfoModalComponent,
			componentProps: {
				article,
				compound: article?.compound,
			},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
	}

	dismiss() {
		this.modalCtrl.dismiss();
	}

	isAllergens(article: Article) {
		if (article?.compound?.allergens) {
			return Object.entries(article?.compound?.allergens)?.find(it => it[0] !== 'gluten' && it[1] === true);
		} else {
			return null;
		}
	}

	isAddit(article: Article) {
		if (article?.compound?.additives) return Object.values(article?.compound?.additives)?.find(it => it === true);
		else return null;
	}

	isTraces(article: Article) {
		if (!article?.compound?.traces) {
			return null;
		}
		return Object.values(article?.compound?.traces).find(it => it === true);
	}
	isHaveAnyValueMoreZero(article: Article) {
		return Object.values(article.nutritions)
			.map(it => (numberD(it) ? numberD(it) : 0))
			.find(it => it > 0);
	}
	convertNumber(value: NutritionValue | undefined) {
		if (!value) {
			return '';
		}
		return numberD(value).toString().replace('.', ',');
	}
}
